import { render } from "./FloatingTimer.vue?vue&type=template&id=cf793eca&scoped=true"
import script from "./FloatingTimer.vue?vue&type=script&lang=js"
export * from "./FloatingTimer.vue?vue&type=script&lang=js"

import "./FloatingTimer.vue?vue&type=style&index=0&id=cf793eca&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf793eca"]])

export default __exports__